import { createSlice } from "@reduxjs/toolkit";

export const freePaymentSlice = createSlice({
  name: "freePayment",
  initialState: {  
    selectedCustomer:{
      code: "",
      description: "",
      tckn : "", 
      id: -1,
      email : "",
      phone: ""

    }
  },
  reducers: { 
    onSelectFreePaymentCustomer: (state, action) => {
      state.selectedCustomer = action.payload; 
      return state;
    },
    clearFreePaymentCustomer: (state, action) => {
      state.selectedCustomer = {}; 
      return state;
    },
  },
});
export const { onSelectFreePaymentCustomer, clearFreePaymentCustomer } = freePaymentSlice.actions;

 

export const freePaymentReducer = freePaymentSlice.reducer;









